var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v("流量池")]), _c("div", [_c("el-radio-group", {
    attrs: {
      size: "mini"
    },
    on: {
      input: _vm.changeFlowPool
    },
    model: {
      value: _vm.selectValue,
      callback: function callback($$v) {
        _vm.selectValue = $$v;
      },
      expression: "selectValue"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1,
      border: "",
      size: "medium"
    }
  }, [_vm._v("限制")]), _c("el-radio", {
    attrs: {
      label: 2,
      border: "",
      size: "medium"
    }
  }, [_vm._v("普通")]), _c("el-radio", {
    attrs: {
      label: 3,
      border: "",
      size: "medium"
    }
  }, [_vm._v("优质")]), _c("el-radio", {
    attrs: {
      label: 4,
      border: "",
      size: "medium"
    }
  }, [_vm._v("极佳")]), _c("el-radio", {
    attrs: {
      label: 5,
      border: "",
      size: "medium"
    }
  }, [_vm._v("官方精选")])], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };